module.exports = __webpack_public_path__ + "static/media/HoloConnect_2.88958da1.png";